// Full-document render of the embeddable footer-only fragment
// (FooterIFrameView). PageSkeleton renders the site footer but omits the
// header and the <main> wrapper. OneTrust is left at its default (unlike the
// nav fragment). messages={false} threads an empty list -- the view pairs
// this with include_messages=False so the flash-messages queue is not
// drained. The iframe-resizer contentWindow script is appended as a child;
// unlike the nav fragment there is no iFrameResizer config object here.
import React from "react";

import { Context, templates } from "@reactivated";

import { useSSRNonce } from "@thelabnyc/thelabui/src/hooks/useSSRNonce";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.FooterIFrameDocumentTemplate,
): React.JSX.Element => {
    const staticBase = React.useContext(Context).chrome.static_base;
    const nonce = useSSRNonce();
    return (
        <PageSkeleton
            pageChrome={props.page_chrome}
            header={false}
            wrapMain={false}
            messages={false}
        >
            <script
                src={`${staticBase}dist2/iframe-resizer/iframeResizer.contentWindow.js`}
                nonce={nonce}
                suppressHydrationWarning={true}
            />
        </PageSkeleton>
    );
};
